export const companyNumberSelectorInitialState = {
  loading: false,
  userClickedSearch: false,
  showCompanyData: false,
  showManualEntry: false,
  showVatField: false,
  apiErrorMessage: null,
};

export const companyNumberSelectorReducer = (state, action) => {
  switch (action.type) {
    case 'SET_IS_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'SET_CLICKED_SEARCH':
      return { ...state, userClickedSearch: true };
    case 'UNSET_CLICKED_SEARCH':
      return { ...state, userClickedSearch: false };
    case 'UNSET_API_ERROR':
      return { ...state, showApiError: false };
    case 'SET_SUCCESS':
      return {
        ...state,
        showCompanyData: true,
        showManualEntry: false,
        showVatField: true,
        apiErrorMessage: null,
      };
    case 'SET_MANUAL':
      return {
        ...state,
        showCompanyData: false,
        showManualEntry: true,
        showVatField: true,
        apiErrorMessage: {
          title: 'Company search is currently unavailable',
          body: 'Your company number will be checked manually',
        },
      };
    case 'SET_ALERT_ERROR_ONLY':
      return {
        ...state,
        showCompanyData: false,
        showManualEntry: false,
        showVatField: false,
        apiErrorMessage: {
          title: action.payload.title,
          body: action.payload.body || null,
        },
      };
    case 'RESET':
      return companyNumberSelectorInitialState;
    default:
      return state;
  }
};
